var React = require('react');

function BellInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.9999 26.334C12.4666 26.334 13.6666 25.134 13.6666 23.6673H8.33325C8.33325 25.134 9.51992 26.334 10.9999 26.334ZM18.9999 18.334V11.6673C18.9999 7.57398 16.8133 4.14732 12.9999 3.24065V2.33398C12.9999 1.22732 12.1066 0.333984 10.9999 0.333984C9.89325 0.333984 8.99992 1.22732 8.99992 2.33398V3.24065C5.17325 4.14732 2.99992 7.56065 2.99992 11.6673V18.334L0.333252 21.0007V22.334H21.6666V21.0007L18.9999 18.334Z","fill":"#1B2B4C"}));
}

BellInline.defaultProps = {"width":"22","height":"27","viewBox":"0 0 22 27","fill":"none"};

module.exports = BellInline;

BellInline.default = BellInline;
